import api from './api';
import StorageService from './StorageService';

class ProjectTeamScheduleService {
    // Get all project team schedules
    static async getAll(page = 1, limit = 20, filters = {}) {
        try {
            const params = new URLSearchParams({
                page: page.toString(),
                limit: limit.toString(),
                ...filters
            });
            const response = await api.get(`/project-team-schedules?${params}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Get project team schedule by ID
    static async getById(id) {
        try {
            const response = await api.get(`/project-team-schedules/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Get project team schedules by project ID
    static async getByProjectId(projectId) {
        try {
            const response = await api.get(`/project-team-schedules/project/${projectId}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Create new project team schedule
    static async create(data) {
        try {
            const payload = { ...data, createdBy: StorageService.loginData().employeeId };
            const response = await api.post('/project-team-schedules', payload);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Update project team schedule
    static async update(id, data) {
        try {
            const payload = { ...data, updatedBy: StorageService.loginData().employeeId };
            const response = await api.put(`/project-team-schedules/${id}`, payload);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Update project team schedule status
    static async updateStatus(id, status) {
        try {
            const payload = { status, updatedBy: StorageService.loginData().employeeId };
            const response = await api.patch(`/project-team-schedules/${id}/status`, payload);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Create multiple team schedules (bulk)
    static async createBulk(teamSchedules) {
        try {
            const response = await api.post('/project-team-schedules/bulk', { teamSchedules });
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default ProjectTeamScheduleService;